import {uniqueId} from 'lodash';
import * as types from './types';
import {Action} from '../../../types/redux';
import {removeLatest} from 'common/utils';

export const notificationsInitialState = {
   toasts: [] as types.IToast[],
   list: [] as types.IToast[],
};

const notificationsReducer = (state = notificationsInitialState, action: Action) => {
   switch (action.type) {
      case types.PUSH_TOAST: {
         const toast = {
            id: uniqueId('toast'),
            time: new Date(),
            ...action.payload,
         };
         return {
            ...state,
            toasts: [...state.toasts, toast],
            list: [toast, ...state.list],
         };
      }
      case types.CLOSE_TOAST:
         return {
            ...state,
            toasts: removeLatest(state.toasts, (val) => val.id === action.payload),
            // list: [state.toast, ...state.list],
         };

      case types.REMOVE_ALL_TOASTS:
         return {
            ...state,
            list: [],
         };

      case types.REMOVE_TOAST:
         return {
            ...state,
            list: removeLatest(state.list, (val) => val.id === action.payload),
         };
      default:
         return state;
   }
};

export default notificationsReducer;
